module.exports = __webpack_public_path__ + "static/media/up-carrot-white.6648b5cd.svg";